import { Button } from "@mui/material";
import styled from "styled-components";

export const StyledStack = styled.div`
  background-color: #fff;
  width: 100%;
  height: 100vh;
  padding: 20px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 900000;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
`;

export const StyledMainDiv = styled.div`
  margin-top: 30px;
`;

export const StyledHelp = styled.div`
  font-size: 14px;
  color: #6d6d6d;
  text-align: right;
  margin-top: 30px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`;

export const StyledDescription = styled.p`
  margin-top: 15px;
  font-size: 13px;
  color: #6d6d6d;
`;

export const StyledTitle = styled.h2`
  font-size: 17px;
`;

export const Phelper = styled.p`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledLogoDiv = styled.div`
  margin: auto;
  width: 70px;
  margin-bottom: 20px;
`;

export const StyledCheckDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledButton = styled(Button)`
  margin-top: 20px !important;
  width: 100%;
`;
